import { createUseStyles } from "react-jss";
import colors from "../../constants/colors";

const styles = createUseStyles({
  mainContainer: {
    // important! safari compatibility
    flex: "1 0 auto",
    gap: "6px",
  },
  mainContainerDisabled: {
    cursor: "not-allowed",
  },
  readOnly: {
    pointerEvents: "none",
  },
  label: {
    color: "var(--mela-text-primary)",
    fontFamily: "'Poppins', sans-serif",
    fontSize: "0.82rem",
    fontWeight: 600,
    lineHeight: 1.4,
    paddingRight: "36px",
    // flex: 1,
  },
  focused: {
    color: colors.blue,
  },
  errorLabel: {
    flex: 1,
  },
  inputContainer: {
    borderRadius: "6px",
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: "var(--mela-border-default)",
    flexDirection: "row",
    "-webkit-flex-direction": "row",
    backgroundColor: "white",
    alignItems: "center",
    padding: "0 12px",
    minHeight: "40px",
    position: "relative",
    transition:
      "border-color 0.24s ease, background-color 0.24s ease, box-shadow 0.24s ease",

    "&:hover": {
      borderColor: "var(--mela-border-strong)",
    },

    "&:focus-within": {
      borderColor: "var(--mela-color-primary)",
      boxShadow: "0 0 0 3px var(--mela-color-primary-focus-ring)",
      outline: "none",
    },
  },

  valueContainer: {
    minWidth: 0,
    flex: 1,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },

  input: {
    border: "transparent !important",
    outline: 0,
    flex: 1,
    minWidth: 0,
    fontSize: "16px",
    lineHeight: "22px",
    color: "var(--mela-text-primary)",
    backgroundColor: "transparent",
    maxWidth: "inherit",
    textOverflow: "ellipsis",
    cursor: "pointer",
    fontWeight: 400,

    "&::placeholder": {
      color: "var(--mela-text-muted)",
      opacity: 1,
    },
  },

  actionsContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 4,
    flexShrink: 0,
    marginLeft: 8,
  },

  clearButton: {
    width: 24,
    minWidth: "24px !important",
    height: 24,
    padding: "0 !important",
    borderRadius: "50%",
    boxShadow: "none !important",
    flexShrink: 0,
    overflow: "visible !important",

    "&.mela-button": {
      width: "24px !important",
      minWidth: "24px !important",
      height: "24px !important",
      padding: "0 !important",
      transform: "none !important",
      overflow: "visible !important",
      backgroundColor: "transparent !important",
    },

    "& .mela-button__inner": {
      width: 24,
      height: 24,
      overflow: "visible",
    },

    "& .mela-button__icon-slot": {
      width: 24,
      height: 24,
      overflow: "visible",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },

    "& svg": {
      width: 20,
      height: 20,
      fontSize: 20,
    },

    "&::after": {
      display: "none",
    },

    "&:hover": {
      transform: "none !important",
      boxShadow: "none !important",
      backgroundColor: "transparent !important",
    },
  },

  arrowButton: {
    width: 28,
    minWidth: "28px !important",
    height: 28,
    padding: "0 !important",
    borderRadius: "50%",
    boxShadow: "none !important",
    flexShrink: 0,
    overflow: "visible !important",

    "&.mela-button": {
      width: "28px !important",
      minWidth: "28px !important",
      height: "28px !important",
      padding: "0 !important",
      backgroundColor: "transparent !important",
    },

    "& .mela-button__inner": {
      width: 28,
      height: 28,
      overflow: "visible",
    },

    "& .mela-button__icon-slot": {
      width: 28,
      height: 28,
      overflow: "visible",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },

    "& svg": {
      width: 24,
      height: 24,
      fontSize: 24,
    },

    "&::after": {
      display: "none",
    },

    "&:hover": {
      transform: "none !important",
      boxShadow: "none !important",
      backgroundColor: "transparent !important",
    },
  },

  select: {
    backgroundColor: colors.white,
    width: "100%",
    zIndex: 500,
  },

  option: {
    flexDirection: "row",
    justifyContent: "space-between",
    cursor: "pointer",
    paddingRight: "16px",

    "&:hover": {
      backgroundColor: colors.lightGrey,
    },

    // important! safari compatibility
    flex: "1 0 auto",
  },

  optionLabel: {
    textAlign: "right",
    flexGrow: 1,
  },

  optionColor: {
    width: 24,
    minWidth: 24,
    height: 24,
    minHeight: 24,
    marginLeft: 10,
    borderRadius: 50,
  },

  noOption: {
    flexDirection: "row",
    justifyContent: "space-between",
    cursor: "pointer",
    padding: "8px 16px",
    color: colors.lightGrey,
    flex: "1 0 auto",
  },

  orangeBorder: {
    borderColor: colors.error,
  },

  showOutline: {
    borderColor: colors.input.filled,
  },

  inputContainerFocused: {
    borderColor:
      "var(--mela-input-focus-border-color, var(--mela-color-primary)) !important",
    boxShadow:
      "0 0 0 3px var(--mela-input-focus-ring-color, var(--mela-color-primary-focus-ring))",
    outline: "none",
  },
});

export default styles;
